import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import IconDelete from '../../components/icons/IconDelete';
import IconAccepted from '../../components/icons/IconAccepted';
import IconRemove from '../../components/icons/IconRemove';
import IconEdit from '../../components/icons/IconEdit';

export default function PipeCreatorColumn(props) {

   const [color, setColor] = useState(props.color);
   const [title, setTitle] = useState(props.title);
   const [id, setId] = useState(props.id);
   let flag = 0;
   const [url, setUrl] = useState(props.url+"?stage="+id);
   const navigate = useNavigate();
   const [data,setData] =  useState([]);
   const [satatus, setSatatus] = useState('wait');



    useEffect(() => {
      if(!id) {
        return;
      }
      setUrl(props.url+"?stage="+id)
    },[props.id])

 
    const deleteStageHundler = () => {
      axios.delete(props.url+'/'+id,
        {
            withCredentials: true,
            headers: {
               'Content-Type': 'application/json',
            },
        }
      ).then(response => {
        props.onRefresh();
      }).catch((err) => {
        alert("Немаожливо видалити, скоріш за все на цьому етапі вже є клієнт! Щоб усунути це етап треба з нього прибрати усіх клієнтів");
      });
    }



  return (
    <div className='pipe-creator-column'>
      <div style={{borderBottom:`3px solid ${color}`}} className='pipe-column-header'>{title}</div>
        <div className='pipe-creator-buttons'>
          <IconRemove fillColor={'icon-red'} onClick={deleteStageHundler} />
          <IconEdit fillColor={'icon-green'}  />
        </div>
    </div>
  )
}
